import React from 'react';
import superagent from 'superagent';
import { Divider, Header } from 'semantic-ui-react'

import BigOrderTable from '../../../BigOrders/BigOrderTable.jsx';
import * as ApiUtils from '../../../CloudApi/ApiUtils.js';

export default class AccountBigOrderList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bigOrders: []
        };
    }

    async componentDidMount() {
        return this.reload();
    }

    async reload() {
        this.setState({ loading: true });
        try {
            let schemas = await ApiUtils.getFabricatorSchemas();
            this.setState({ schemas });
            
            this.setState({ bigOrders: [] });
            const res = await superagent.get(`/api/admin/shop/account/${this.props.account.id}/orders`).accept('json');
            console.log(res.body);
            this.setState({ bigOrders: res.body.items });
        } catch (e) {
            console.log(e);
        }
        this.setState({ loading: false });
    }

    render() {
        return (
            <div>
                <Header as="h2">Big Orders</Header>
                <BigOrderTable loading={this.state.loading} schemas={this.state.schemas} orders={this.state.bigOrders} showDetail={false} />
            </div>
        );
    }
}
